import { AppStates } from '../../reducers/app';
import { connect } from 'react-redux';
import * as React from 'react';
import { IndexedSpreadBlock } from '../../types/epub';
import { Dimension } from '../../types/common';
import Thumbnail, { ThumbnailProps } from './Thumbnail';

function defaultStyle({ width, height }: Dimension): Readonly<React.CSSProperties> {
  return {
    height,
    width: width * 2,
    marginLeft: 8,
    marginRight: 8,
    display: 'flex',
    backgroundColor: 'rgba(255, 255, 255, 0.5)',
  };
}

function focusedStyle(dimention: Dimension): Readonly<React.CSSProperties> {
  return {
    ...defaultStyle(dimention),
    marginLeft: 4,
    marginRight: 4,
    marginTop: -4,
    marginBottom: -4,
    borderWidth: 4,
    borderColor: '#00F',
    borderStyle: 'solid',
  };
}

interface ThumbnailSpreadProps {
  readonly spread: Readonly<IndexedSpreadBlock>;
  readonly currentPage: number;
  readonly dir: string;
  readonly thumbnailSize: Dimension;
  readonly onClick: (page: number) => any;
}

const ThumbnailSpread: React.SFC<ThumbnailSpreadProps> = (props: ThumbnailSpreadProps) => {
  const {
    dir,
    thumbnailSize,
    spread,
    currentPage,
    onClick,
  } = props;
  const { index: page } = spread;
  if (!spread.center) {
    const { left, right } = spread;
    const isCurrent = page === currentPage || left && right && page === currentPage - 1;
    const style = isCurrent ? focusedStyle(thumbnailSize) : defaultStyle(thumbnailSize);
    const leftSrc = left && left.thumbnail && `${dir}/${left.thumbnail.path}`;
    const rightSrc = right && right.thumbnail && `${dir}/${right.thumbnail.path}`;
    if (left) {
      const leftPageProp: ThumbnailProps = {
        ...thumbnailSize,
        src: leftSrc,
        label: `${page + 1}`,
        onClick: () => onClick(page),
      };
      if (right) {
        return <div style={style}>
          <Thumbnail {...leftPageProp} />
          <Thumbnail
            src={rightSrc}
            label={`${page + 2}`}
            labelAlign="right"
            onClick={() => onClick(page + 1)}
            {...thumbnailSize} />
        </div>;
      }
      return <div style={style}><Thumbnail {...leftPageProp} /></div>;
    }
    return <div style={{ ...style, flexDirection: 'row-reverse' }}>
      <Thumbnail
        src={rightSrc}
        label={`${page + 1}`}
        labelAlign="right"
        onClick={() => onClick(page)}
        {...thumbnailSize} />
    </div>;
  }
  const { center } = spread;
  const style = page === currentPage ? focusedStyle(thumbnailSize) : defaultStyle(thumbnailSize);
  const src = center && center.thumbnail && `${dir}/${center.thumbnail.path}`;
  return <div key={center.path} style={style}>
    <Thumbnail
      src={src}
      label={`${page + 1}`}
      width={thumbnailSize.width * 2}
      height={thumbnailSize.height}
      onClick={() => onClick(page)} />
  </div>;
};

const mapStateToProp = (appStates: AppStates) => ({ dir: appStates.publication!.resourceDir });

export default connect(mapStateToProp)(ThumbnailSpread);

interface EmptySpreadProps {
  thumbnailSize: Dimension;
}

export const EmptySpread: React.SFC<EmptySpreadProps> =
  ({ thumbnailSize }: EmptySpreadProps) => <div style={defaultStyle(thumbnailSize)} />;
